import { render, staticRenderFns } from "./InsurerInfoForm.vue?vue&type=template&id=3ad8bc42&scoped=true&"
import script from "./InsurerInfoForm.vue?vue&type=script&lang=js&"
export * from "./InsurerInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8bc42",
  null
  
)

export default component.exports